import { Box } from '@mui/material';
import { useState } from 'react';
import { Tabs } from '@components/tabs/Tabs';
import { TabPanel } from '@components/tabs/tabPanel';
import { QuoteActivityPanel } from '@pages/UnderwriterToolkit/tab-content/QuoteActivityPanel/QuoteActivityPanel';
import { QuoteDetailsPanel } from './QuoteDetailsPanel';
import { useQuoteSummaryHelper } from '@pages/QuoteDetails/sidebarItems/summary/useQuoteSummaryHelper';

const tabs = [
  { label: 'Summary', value: 0 },
  { label: 'Quote Activity', value: 1 },
];

export const QuoteSummaryTab = () => {
  const { quoteId } = useQuoteSummaryHelper();
  const [tabValue, setTabValue] = useState(0);
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box
      sx={{
        px: 2,
        height: '100%', // Take full available height
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <Tabs
        type='mini'
        disableRipple
        value={tabValue}
        onChange={handleChange}
        aria-label='Underwriting Tabs'
        tabOptions={tabs}
      />

      <Box
        sx={{
          flex: 1,
          minHeight: 0, // Allow content to shrink
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto', // Enable scrolling for content
        }}
      >
        <TabPanel selectedTab={tabValue} value={tabs[0].value}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              minHeight: 'fit-content',
            }}
          >
            <QuoteDetailsPanel />
          </Box>
        </TabPanel>
        <TabPanel selectedTab={tabValue} value={tabs[1].value}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              minHeight: 'fit-content',
              overflow: 'auto',
            }}
          >
            {quoteId ? <QuoteActivityPanel quoteId={quoteId} /> : null}
          </Box>
        </TabPanel>
      </Box>
    </Box>
  );
};
